import { SEO } from '../../utils/seo';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  const siteUrl = 'https://superspoon.net';
  
  const schema = {
    '@type': 'WebPage',
    name: 'プライバシーポリシー',
    url: `${siteUrl}/privacy-policy`,
    description: 'スーパースプーンのプライバシーポリシー。個人情報の取り扱いについて説明しています。',
    inLanguage: 'ja-JP',
    isPartOf: {
      '@type': 'WebSite',
      name: 'スーパースプーン',
      url: siteUrl
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="プライバシーポリシー｜スーパースプーン"
        description="スーパースプーンのプライバシーポリシー。お客様の個人情報の取り扱いについて詳しく説明しています。"
        keywords="プライバシーポリシー,個人情報保護,スーパースプーン"
        path="/privacy-policy"
        schema={schema}
      />
      <Header />
      <main className="py-20 px-8">
        <div className="max-w-[900px] mx-auto">
          <h1 className="text-4xl font-bold mb-8 text-[#1A2332]">プライバシーポリシー</h1>
          
          <div className="space-y-8 text-[#1A2332]/80 leading-relaxed">
            <section>
              <p className="mb-6">
                スーパースプーン（以下「当社」といいます）は、お客様の個人情報の保護を重要な責務と考え、以下のプライバシーポリシーを定め、適切な取り扱いと保護に努めます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-file-list-3-line text-[#14B8A6]"></i>
                1. 個人情報の定義
              </h2>
              <p>
                本プライバシーポリシーにおいて「個人情報」とは、個人情報保護法第2条第1項に定義される、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）を指します。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-database-2-line text-[#14B8A6]"></i>
                2. 個人情報の収集
              </h2>
              <p className="mb-4">当社は、以下の目的で個人情報を収集することがあります：</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>お問い合わせへの対応</li>
                <li>サービスの提供・運営</li>
                <li>コンサルティング業務の遂行</li>
                <li>契約の履行</li>
                <li>サービス改善のための分析</li>
                <li>重要なお知らせの通知</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-shield-check-line text-[#14B8A6]"></i>
                3. 個人情報の利用目的
              </h2>
              <p className="mb-4">当社は、収集した個人情報を以下の目的で利用します：</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>お客様からのお問い合わせに対する回答</li>
                <li>サービスの提供、維持、改善</li>
                <li>契約の締結および履行</li>
                <li>料金の請求および決済処理</li>
                <li>サービスに関する情報提供</li>
                <li>マーケティング活動（お客様の同意がある場合）</li>
                <li>不正行為の防止および対応</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-lock-line text-[#14B8A6]"></i>
                4. 個人情報の安全管理
              </h2>
              <p>
                当社は、個人情報の漏洩、滅失または毀損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。また、個人情報を取り扱う従業員や委託先に対して、必要かつ適切な監督を行います。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-share-line text-[#14B8A6]"></i>
                5. 個人情報の第三者提供
              </h2>
              <p className="mb-4">
                当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません：
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合</li>
                <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合</li>
                <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-user-settings-line text-[#14B8A6]"></i>
                6. 個人情報の開示・訂正・削除
              </h2>
              <p className="mb-4">
                お客様は、当社が保有する自己の個人情報について、開示、訂正、追加、削除、利用停止、消去および第三者提供の停止を請求することができます。請求される場合は、以下の問い合わせ先までご連絡ください。
              </p>
              <p>
                ただし、法令により開示等が認められない場合、または開示等により当社の正当な利益を害するおそれがある場合は、開示等をお断りすることがあります。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-cookie-line text-[#14B8A6]"></i>
                7. Cookieの使用
              </h2>
              <p>
                当社のウェブサイトでは、サービスの利便性向上およびアクセス解析のためにCookieを使用することがあります。Cookieの使用を希望されない場合は、ブラウザの設定でCookieを無効にすることができますが、一部のサービスが正常に機能しない場合があります。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-links-line text-[#14B8A6]"></i>
                8. 外部サービスの利用
              </h2>
              <p>
                当社のウェブサイトには、外部サービスへのリンクが含まれる場合があります。これらの外部サービスにおける個人情報の取り扱いについては、各サービスのプライバシーポリシーをご確認ください。当社は、外部サービスにおける個人情報の取り扱いについて責任を負いません。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-refresh-line text-[#14B8A6]"></i>
                9. プライバシーポリシーの変更
              </h2>
              <p>
                当社は、法令の変更や事業内容の変更等に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、当社ウェブサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 text-[#1A2332] flex items-center gap-2">
                <i className="ri-mail-line text-[#14B8A6]"></i>
                10. お問い合わせ窓口
              </h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="mb-2"><strong>事業者名：</strong>スーパースプーン</p>
                <p className="mb-2"><strong>所在地：</strong>大阪府堺市中区平井</p>
                <p className="mb-2"><strong>ウェブサイト：</strong>https://superspoon.net</p>
                <p className="mt-4">
                  個人情報の取り扱いに関するご質問やご相談は、当社ウェブサイトのお問い合わせフォームよりご連絡ください。
                </p>
              </div>
            </section>

            <section className="pt-8 border-t border-gray-200">
              <p className="text-sm text-[#1A2332]/60">
                制定日：2025年1月1日<br />
                最終更新日：2025年1月15日
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
